import { cn } from "core/shared";
import { useEffect } from "react";
import { Button } from "~/design-system/components/button";
import { headerMenuAtom, searchAtom } from "~/modules/shared/atoms";

export function MenuButton() {
  const openMenu = headerMenuAtom.useOpened();

  useEffect(() => {
    if (openMenu) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }

    return () => {
      document.body.style.overflow = "auto";
    };
  }, [openMenu]);

  return (
    <Button
      onClick={() => {
        headerMenuAtom.toggle();
        searchAtom.close();
      }}
      data-ignore-outside-clicks
      className="flex items-center gap-2 rounded-full border border-transparent p-0 text-lg font-medium uppercase hover:border-black lg:gap-4 lg:px-5 lg:py-1.5"
    >
      <BarsIcon open={openMenu} />
      {/* <span className="animate-fade block">
        {openMenu ? trans("close") : trans("menu")}
      </span> */}
    </Button>
  );
}

type BarsIconProps = {
  open: boolean;
};

function BarsIcon({ open }: BarsIconProps) {
  return (
    <div className="relative flex h-8 w-10 flex-col justify-center gap-2">
      <Bar className={cn("top-2.5", open && "top-1/2 -translate-y-1/2")} />
      <Bar className={cn("bottom-2.5", open && "bottom-1/2 translate-y-1/2")} />
    </div>
  );
}

type BarProps = {
  className: string;
};

function Bar({ className }: BarProps) {
  return (
    <span
      className={cn(
        "absolute left-1/2 h-0.5 w-6 -translate-x-1/2 rounded-full bg-black transition-all duration-300 lg:w-10",
        className,
      )}
    />
  );
}
